'use client'

import { usePathname } from 'next/navigation'

import ChevronRight from '@/assets/images/chevron_right.svg'
import Link from '@/components/Link'
import JsonLd from '@/components/seo/JsonLd'
import { breadcrumbSchema, SITE_URL } from '@/utils/schema'

const toLabel = (segment: string) =>
  segment.replaceAll('-', ' ').replaceAll(/\b\w/g, c => c.toUpperCase())

function Breadcrumbs() {
  const pathname = usePathname()

  const segments = pathname.split('/').filter(Boolean)
  const visibleSegments = segments.slice(1)

  // BreadcrumbList JSON-LD built from the same trail shown to users. Home is the
  // implicit root (position 1), followed by each cumulative path segment.
  const schema = breadcrumbSchema([
    { name: 'Home', url: `${SITE_URL}/` },
    ...visibleSegments.map((segment, index) => ({
      name: toLabel(segment),
      url: `${SITE_URL}/${segments.slice(0, index + 2).join('/')}/`
    }))
  ])

  return (
    <nav aria-label="breadcrumb" style={{ marginBottom: '16px' }}>
      {schema && <JsonLd data={schema} />}
      <ol
        style={{
          listStyle: 'none',
          display: 'flex',
          flexWrap: 'wrap',
          padding: 0,
          margin: 0
        }}
      >
        {visibleSegments.map((segment, index) => {
          const href = '/' + segments.slice(0, index + 2).join('/')
          const label = toLabel(segment)

          const isLast = index === visibleSegments.length - 1

          return (
            <li
              key={index}
              style={{
                display: 'flex',
                alignItems: 'center' // ensures vertical centering
              }}
            >
              {isLast ? (
                <span
                  style={{
                    color: '#221AFB',
                    fontWeight: '500',
                    fontSize: '14px', // 👈 font size
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {label}
                </span>
              ) : (
                <Link
                  href={href}
                  style={{
                    color: '#72788E',
                    textDecoration: 'none',
                    fontSize: '14px', // 👈 font size
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {label}
                </Link>
              )}
              {!isLast && (
                <img
                  src={ChevronRight.src}
                  alt="arrow"
                  style={{
                    width: '18px',
                    height: '18px',
                    paddingBottom: '3px',
                    margin: '0 6px',
                    objectFit: 'contain',
                    display: 'inline-block',
                    verticalAlign: 'middle'
                  }}
                />
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

export default Breadcrumbs
